import getField from '@form/formGenerator'

export const userUpdatePasswordUrl = `${import.meta.env.VITE_API_URL}/api/users/update-password`

export const userPasswordFormObject = {
  oldPassword: '',
  password: '',
  passwordConfirmation: ''
}

const userPasswordFormFields = (userPasswordObject, errors, isLoading, updateFormObject, saveForm, t) => {
  const fields = [
    {
      type: 'password',
      name: 'oldPassword',
      label: t('user:labels.old_password'),
      value: userPasswordObject.oldPassword,
      key: 'userPasswordObject-password',
      cssClass: 'column is-12',
      isRequired: true
    },
    {
      type: 'password',
      name: 'password',
      label: t('user:labels.password'),
      value: userPasswordObject.password,
      key: 'userPasswordObject-new-password',
      cssClass: 'column is-12',
      isRequired: true
    },
    {
      type: 'password',
      name: 'passwordConfirmation',
      label: t('user:labels.password_confirmation'),
      value: userPasswordObject.passwordConfirmation,
      key: 'userPasswordObject-passwordConfirmation',
      cssClass: 'column is-12',
      isRequired: true
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('user:actions.update'),
      cssClass: 'column is-12',
      cssClassValidate: isLoading ? 'is-blue is-loading' : 'is-blue',
      validateIcon: 'icon-done',
      key: 'commonData-form',
      isLoading
    },
    {
      type: 'hidden',
      name: '_csrf_token',
      value: userPasswordObject.token,
      key: 'userPasswordObject-token'
    }
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject)
  })
}

export default userPasswordFormFields
